import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { QuizSummary } from "../../services/api";

interface QuizState {
    live: QuizSummary[];
    activeQuizId?: string;
}

const initialState: QuizState = {
    live: []
};

const quizSlice = createSlice({
    name: "quiz",
    initialState,
    reducers: {
        setLiveQuizzes(state: QuizState, action: PayloadAction<QuizSummary[]>) {
            state.live = action.payload;
        },
        setActiveQuiz(state: QuizState, action: PayloadAction<string | undefined>) {
            state.activeQuizId = action.payload;
        }
    }
});

export const { setLiveQuizzes, setActiveQuiz } = quizSlice.actions;
export default quizSlice.reducer;
